import { Injectable } from '@angular/core';

import { IStorage } from './interfaces/istorage';

@Injectable({
    providedIn: "root"
})
export class LocalStorage implements IStorage {

    clear(): void {
        localStorage.clear();
    }

    getItem(key: string): string {
        var result = localStorage.getItem(key);
        return result;
    }

    setItem(key: string, data: string): void {
        localStorage.setItem(key, data);
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }
}
